module.exports = __webpack_public_path__ + "static/media/curateTheLook.da679217.mp4";